<template>
  <div id="zarpes">
    <table class="w-100" border="0" align="center">
      <tr>
        <td class="background-app padding-ios" colspan="4" align="center" width="100%" height="40">
          ZARPES ASIGNADOS
        </td>
      </tr>
      <tr class="header" bgcolor="#CCCCCC">
        <td align="center" height="30">
          <strong>ID Pago</strong>
        </td>
        <td align="center" width="100">
          <strong>Fecha</strong>
        </td>
        <td align="center">
          <strong>Destino</strong>
        </td>
        <td align="center">
          <strong>Inicio</strong>
        </td>
      </tr>
      <tr
        v-for="zarpe in zarpes"
        :key="zarpe.id_pay"
        class="font-14"
        :class="{ hightlight: !zarpe.state }"
        style="border-bottom: 1px solid #ccc"
        @click="goToZarpe(zarpe.id_pay)"
      >
        <td align="center" height="50" width="90">{{ zarpe.id_pay }}</td>
        <td align="center" width="100">{{ zarpe.date | date }}</td>
        <td align="center">{{ zarpe.section }}</td>
        <td align="center">{{ zarpe.hour_init | hour }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import http from '../http'

export default {
  name: 'Zarpes',
  data() {
    return {
      zarpes: []
    }
  },
  created() {
    this.loadZarpes()
  },
  filters: {
    date(value) {
      if (!value || value === 'null' || value === 'undefined') return ''
      // Parsear como y-MM-dd y formatear como dd MMM y
      const date = new Date(value)
      if (isNaN(date.getTime())) return ''

      const day = date.getDate().toString().padStart(2, '0')
      const month = date.toLocaleDateString('es-CL', { month: 'short' }).toUpperCase()
      const year = date.getFullYear()

      return `${day} ${month} ${year}`.replace('.', '')
    },
    hour(value) {
      if (!value || value === 'null' || value === 'undefined') return ''

      if (typeof value === 'string' && value.match(/^\d{2}:\d{2}:\d{2}$/)) {
        const [hours, minutes] = value.split(':')
        const hourNum = parseInt(hours)
        const minuteNum = parseInt(minutes)
        const ampm = hourNum >= 12 ? 'PM' : 'AM'
        const displayHours = hourNum % 12 || 12

        return `${displayHours.toString().padStart(2, '0')}:${minuteNum.toString().padStart(2, '0')} ${ampm}`
      }

      const date = new Date(value)
      if (isNaN(date.getTime())) return ''

      const hours = date.getHours()
      const minutes = date.getMinutes()
      const ampm = hours >= 12 ? 'PM' : 'AM'
      const displayHours = hours % 12 || 12

      return `${displayHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`
    }
  },
  methods: {
    loadZarpes() {
      this.$root.loading = true
      http.get('app/service/zarpe/all')
        .then(res => {
          this.$root.loading = false
          this.zarpes = Object.values(res.body.services)
        })
        .catch(err => {
          this.$root.catchErrorApi(err)
        })
    },
    goToZarpe(idPay) {
      this.$router.push(`/zarpe/${idPay}`)
    }
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/Zarpes.vue